<div class="container-fluid maap-root-container">
    <app-header
                (deIdChange)="updateDeIdMode($event)" 
                [deId]="deId"
                [dissableDeIdSwitch]="dissableDeIdSwitch">
    </app-header>

    <app-sidebar [deId]="deId"
                 [dissableDeIdSwitch]="dissableDeIdSwitch"
                 (deIdChange)="updateDeIdMode($event)">
    </app-sidebar>

    <header class="standalone-page-header variance-page-header">
        <h1 class="standalone-page-title">Variances</h1>
    </header>

    <div class="row">
            <div class="col-md-12 px-3">
                <p-tabs [value]="activeTab" (valueChange)="tabChanged($event)">
                    <p-tablist>
                        <p-tab value="0">ADC</p-tab>
                        <p-tab value="1">EHR</p-tab>
                        <p-tab value="2">Normalized Data</p-tab>
                        <p-tab value="3">All Variances</p-tab>
                        <div class="multiAdminCheckbox" *ngIf="showMultiAdminsCheckbox === true">
                            <p-checkbox [binary]="true" [(ngModel)]="showUnreconciledDosesOnly" (onChange)="changeShowUnreconciledDosesOnly()"></p-checkbox>
                            <label id="VP_multiAdmin">Unreconciled Doses</label>
                            <div tabindex="0" class="variance-link-records" (click)="linkRecords()" (keydown.enter)="linkRecords()">
                                <img class="variance-link-image mx-2" src="/assets/images/icon_Linked-Transaction.png" alt="">
                                <label>Link Variance Records</label>
                            </div>
                        </div>
                    </p-tablist>
                    <app-data-filter-pills class="page-filter-pills" [filterValues]="filterValues" [deId]="deId" (filterVal)="removeFilter($event)" (filterInputs)="openFilterModuleAfterMore($event)"></app-data-filter-pills>
                    <p class="variance-date-range" *ngIf="dateRange">
                        <strong>Date Range:</strong>
                        {{dateRange.startDate | date : 'MM/dd/yyyy | HH:mm'}} through {{dateRange.endDate | date : 'MM/dd/yyyy | HH:mm'}}
                    </p>
                    <p-tabpanels>
                        <p-tabpanel value="0">
                            <app-adc #adc [lookbackPeriod]="selectedDays" [quickTimeOptions]="days" [active]="activeTab === '0'" (lookbackPeriodChange)="updateLookbackPeriod($event)" (filterValue)="updatedFilterValue($event)" (dateValue)="updatedDate($event)"></app-adc>
                        </p-tabpanel>
                        <p-tabpanel value="1">
                            <app-ehr #ehr [lookbackPeriod]="selectedDays" [quickTimeOptions]="days" [active]="activeTab === '1'" (lookbackPeriodChange)="updateLookbackPeriod($event)" (filterValue)="updatedFilterValue($event)" (dateValue)="updatedDate($event)"></app-ehr>
                        </p-tabpanel>
                        <p-tabpanel value="2">
                            <app-normalized-data #normData [lookbackPeriod]="selectedDays" [quickTimeOptions]="days" [active]="activeTab === '2'" (lookbackPeriodChange)="updateLookbackPeriod($event)" (filterValue)="updatedFilterValue($event)" (dateValue)="updatedDate($event)"></app-normalized-data>
                        </p-tabpanel>
                        <p-tabpanel value="3">
                            <app-urc #urc [lookbackPeriod]="selectedDays" [quickTimeOptions]="days" [include_csn]="include_csn" [isAuditor]="false" [active]="activeTab === '3'" (lookbackPeriodChange)="updateLookbackPeriod($event)" (filterValue)="updatedFilterValue($event)" (dateValue)="updatedDate($event)"></app-urc>
                        </p-tabpanel>
                    </p-tabpanels>
                </p-tabs>
            </div>
        </div>
</div>
